import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowOnlyWhenVisibleDirective } from 'ZalamoLibrary/src/lib/ui/directives/show-only-if-visible/show-only-when-visible.directive';

@NgModule({
  declarations: [ShowOnlyWhenVisibleDirective],
  exports: [ShowOnlyWhenVisibleDirective],
  imports: [CommonModule],
})
export class ShowOnlyIfVisibleModule {}
